import { themeGet } from '@styled-system/theme-get';
import styled from 'styled-components';

const Section = styled.section`
  padding: 96px 0;
  background: ${themeGet('colors.background')};
  @media (max-width: 768px) {
    padding: 64px 0;
  }
`;

export const Grid = styled.div`
  display: grid;
  grid-template-columns: minmax(0, 0.9fr) minmax(0, 1.1fr);
  align-items: center;
  gap: 72px;
  @media (max-width: 991px) {
    grid-template-columns: 1fr;
    gap: 44px;
  }
`;

export const Content = styled.div`
  min-width: 0;
`;

export const SectionHeading = styled.div`
  @media (max-width: 991px) {
    text-align: center;
  }
  .subtitle {
    color: ${themeGet('colors.secondaryDark')};
    font-size: 16px;
    font-weight: 700;
    line-height: 1.4;
  }
  h2 {
    max-width: 520px;
    font-weight: 800;
    font-size: 40px;
    line-height: 1.25;
    letter-spacing: -0.03em;
    @media (max-width: 991px) {
      margin-left: auto;
      margin-right: auto;
    }
    @media (max-width: 600px) {
      font-size: 28px;
    }
  }
  .description {
    max-width: 520px;
    color: ${themeGet('colors.textColor')};
    font-size: 16px;
    line-height: 1.8;
    @media (max-width: 991px) {
      margin-left: auto;
      margin-right: auto;
    }
  }
  .explore {
    display: inline-flex;
    margin-top: 18px;
    button {
      border: 1px solid ${themeGet('colors.headingColor')};
      border-radius: 50px;
      padding: 14px 20px;
      color: ${themeGet('colors.white')};
      background: ${themeGet('colors.primary')};
      &:hover {
        background: ${themeGet('colors.primaryHover')};
      }
      svg {
        font-size: 20px;
      }
    }
  }
`;

export const CommunityPanel = styled.div`
  min-width: 0;
  padding: 28px;
  border: 1px solid ${themeGet('colors.borderColorMuted')};
  border-radius: 28px;
  background: ${themeGet('colors.white')};
  box-shadow: ${themeGet('colors.cardShadow')};
  @media (max-width: 560px) {
    padding: 18px;
    border-radius: 20px;
  }
`;

export const FeatureGrid = styled.div`
  display: grid;
  gap: 16px;
`;

export const FeatureCard = styled.article`
  display: flex;
  align-items: flex-start;
  gap: 18px;
  padding: 22px;
  border: 1px solid ${themeGet('colors.borderColorMuted')};
  border-radius: 18px;
  background: ${themeGet('colors.surfaceRaised')};
  > span {
    width: 48px;
    height: 48px;
    border-radius: 50%;
    display: grid;
    place-items: center;
    flex: 0 0 48px;
    color: ${themeGet('colors.headingColor')};
    background: ${themeGet('colors.secondary')};
    font-size: 24px;
  }
  h3 {
    margin-bottom: 5px;
    font-size: 18px;
    line-height: 1.4;
  }
  p {
    margin: 0;
    color: ${themeGet('colors.textColor')};
    font-size: 15px;
    line-height: 1.65;
  }
  @media (max-width: 480px) {
    padding: 18px;
  }
`;

export default Section;
